import { render, staticRenderFns } from "./UabZipUpload.vue?vue&type=template&id=4f258081&"
import script from "./UabZipUpload.vue?vue&type=script&lang=js&"
export * from "./UabZipUpload.vue?vue&type=script&lang=js&"
import style0 from "./UabZipUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports